import { FINGER_TYPE, HAND_TYPE } from '../../../constants/Consts';
import { keyInfo } from '../../../types/Typing';

interface HandElementProps {
  width: string;
  handType: HAND_TYPE;
  currentKeyInfo: keyInfo | undefined;
  currentChar?: string | undefined;
  usingShiftKeys?: (string | undefined)[];
  isShiftMode?: boolean | undefined;
}

const fingerTypes: FINGER_TYPE[] = [FINGER_TYPE.LITTLE, FINGER_TYPE.RING, FINGER_TYPE.MIDDLE, FINGER_TYPE.INDEX, FINGER_TYPE.THUMB];

export const HandElement = ({ width, handType, currentKeyInfo, currentChar, usingShiftKeys, isShiftMode }: HandElementProps) => {
  const getFingerImage = (finger: FINGER_TYPE) => {
    let fingerImage = finger as string;
    if (!currentKeyInfo) {
      return fingerImage;
    }

    // スペースキーを入力する場合（ゲームスタート時のみ）
    if (currentKeyInfo.handType === HAND_TYPE.BOTH) {
      return `${fingerImage}${currentKeyInfo.fingerType === finger ? '_input' : ''}`;
    }

    // シフトキーを使用する場合
    if (usingShiftKeys && usingShiftKeys.includes(currentChar)) {
      if (finger === FINGER_TYPE.LITTLE && currentKeyInfo.handType !== handType) {
        fingerImage = `${fingerImage}${isShiftMode ? '_shift_keydown' : '_input'}`;
      }
      if (isShiftMode && currentKeyInfo.fingerType === finger && currentKeyInfo.handType === handType) {
        fingerImage = `${fingerImage}${'_input'}`;
      }
      return fingerImage;
    }

    // 通常入力
    if (currentKeyInfo.fingerType === finger && currentKeyInfo.handType === handType) {
      fingerImage = `${fingerImage}${'_input'}`;
    }
    return fingerImage;
  };

  return (
    <div className={`relative w-[${width}]`}>
      <img className="absolute" src={`/keyboard/${handType}/base.webp`} alt="ベース" />
      {fingerTypes.map((finger: FINGER_TYPE) => {
        const fingerImage = getFingerImage(finger);
        return (
          <img key={`${handType}_${finger}`} className="absolute" src={`/keyboard/${handType}/${fingerImage}.webp`} alt={`${handType}_${finger}`} />
        );
      })}
    </div>
  );
};
